<template>
   <v-dialog v-model="isVisible" persistent max-width="1200" v-if="order">
        <v-toolbar dark color="primary">
            <v-icon>shopping_cart</v-icon>
            <v-toolbar-title class="white--text" >#  WS-{{ order.wo_eventid }}-{{ order.id }} // </v-toolbar-title>
              <v-layout row >
                <div>
                  <v-chip :color="order.PaymentStatus ? 'green' : 'secondary'" text-color="white">
                    <span v-if="order.PaymentStatus">Paid</span>
                    <span v-else>Not paid</span>
                  </v-chip>
                  <v-chip :color="order.ShippingStatus ? 'green' : 'secondary'" text-color="white">
                    <span v-if="order.ShippingStatus" @click="openTrackingPage()" style="cursor:pointer;">Shipped</span>
                    <span v-else>Not shipped</span>
                  </v-chip>
                  <v-chip v-if="order.PlacedByFohes" color="green" text-color="white">
                    <span>Placed by FOHES</span>
                  </v-chip>
                  <v-chip v-if="order.FOHESInvoiceNumber" color="green" text-color="white">
                    <span>FIN: {{order.FOHESInvoiceNumber}}</span>
                  </v-chip>
                  <v-chip v-if="order.FOHESConfirmationNumber" color="green" text-color="white">
                    <span>FCN: {{order.FOHESConfirmationNumber}}</span>
                  </v-chip>
                  <v-chip v-if="order.wo_status === -2" color="red" text-color="white">
                    <span>Order canceled</span>
                  </v-chip>
                  <v-chip  color="cyan" v-if="order.wo_partner_name" text-color="white">
                    <span>{{ order.wo_partner_name }}</span>
                  </v-chip>
                  <v-chip color="black" text-color="white">
                      <span>{{ paymentType }}</span>
                  </v-chip>
                  
                  <v-chip v-if="order.customerInvoice" color="black" text-color="white">
                      <span @click="openInvoicePage()">{{ order.customerInvoice }}</span>
                  </v-chip>

                </div>
              </v-layout>

            <v-btn icon @click="close">
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-tabs
            v-model="tab"
            dark
            color="primary"
            style="height:0px">
            <!-- <v-tab href="#tab-settings">
                Order details
            </v-tab> -->
        </v-tabs>
        <v-card >
            <v-card-text>
                <v-tabs-items v-model="tab">
                    <v-tab-item value="tab-settings">
                      <v-container grid-list-lg md6 >
                        <v-layout row>
                          <v-flex :xs6="order.RgDaAdress !== 0" :xs12="order.RgDaAdress === 0">
                            <address-box :customer-id="order.RgAdress" :order="order"></address-box>
                          </v-flex>
                          <v-flex xs6 v-if="order.RgDaAdress !== 0">
                            <address-box :customer-id="order.RgDaAdress" :is-delivery-address="true" :order="order"></address-box> 
                          </v-flex>
                        </v-layout>
                        
                        <v-layout row>
                          <v-flex xs12>
                            <article-list :order-id="order.id"></article-list>
                            <br>
                          </v-flex>
                        </v-layout>
                        
                        <v-layout row>
                          <v-flex xs12>
                              <div class="text-xs-center button-row">
                                <v-tooltip bottom>
                                    <v-btn slot="activator" fab dark :color="order.PaymentStatus ? 'teal': 'indigo'" @click="onMarkAsPaid">
                                        <v-icon dark>attach_money</v-icon>
                                    </v-btn>
                                    <span>Mark as paid</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <v-btn slot="activator" fab dark :color="order.PlacedByFohes ? 'teal': 'indigo'" @click="isPlacedWithFOHESVisible = !isPlacedWithFOHESVisible">
                                      <v-icon dark>wb_iridescent</v-icon>
                                    </v-btn>
                                    <span>Placed with FOHES</span>
                                </v-tooltip>
                                 <v-tooltip bottom>
                                    <v-btn slot="activator" fab dark :color="order.ShippingTrackingNumber !== '' ? 'teal': 'indigo'" @click="isMarkAsShippedVisible = !isMarkAsShippedVisible">
                                      <v-icon dark>local_shipping</v-icon>
                                    </v-btn>
                                    <span>Mark as shipped</span>
                                </v-tooltip>
                                <v-tooltip bottom v-if="user.settings.orderHistoryShowRequiredLogo">
                                  <v-btn slot="activator" fab dark :color="order.RequiredLogo !== '' ? 'teal': 'indigo'" @click="isRequiredLogoVisible = !isRequiredLogoVisible">
                                    <v-icon dark>image</v-icon>
                                  </v-btn>
                                  <span>Required Logo</span>
                                </v-tooltip>
                                <v-tooltip bottom >
                                  <v-btn slot="activator" fab dark :color="order.RequiredLogo !== '' ? 'teal': 'indigo'" @click="isOrderInfoVisible = !isOrderInfoVisible">
                                    <v-icon dark>info</v-icon>
                                  </v-btn>
                                  <span>Order Info</span>
                                </v-tooltip>
                                <v-tooltip bottom >
                                  <v-btn slot="activator" fab dark :color="order.RequiredLogo !== '' ? 'teal': 'indigo'" @click="isOrderPaymentDateVisible = !isOrderPaymentDateVisible">
                                    <v-icon dark>receipt</v-icon>
                                  </v-btn>
                                  <span>Payment Date</span>
                                </v-tooltip>
                              </div>
                              <div>
                                  <div v-if="isMarkAsShippedVisible">
                                       <v-text-field label="Shipping number" v-model="order.ShippingTrackingNumber"></v-text-field> 
                                       <v-btn color="info" @click="onMarkAsShipped">{{$t('message.save')}}</v-btn>
                                  </div>
                                  <div v-if="isPlacedWithFOHESVisible">
                                      <v-text-field label="FOHES invoice number" v-model="order.FOHESInvoiceNumber"></v-text-field>
                                      <v-text-field label="FOHES confirmation number" v-model="order.FOHESConfirmationNumber"></v-text-field>
                                      <v-btn color="info" @click="onMarkAsPlacedWithFOHES">{{$t('message.save')}}</v-btn>
                                  </div>
                                   <div v-if="isRequiredLogoVisible">
                                        <v-combobox
                                          v-model="order.RequiredLogo"
                                          :items="logos"
                                          label="Logo"
                                        ></v-combobox>
                                       <v-btn color="info" @click="onSaveRequiredLogo">{{$t('message.save')}}</v-btn>
                                  </div>
                                  <div v-if="isOrderInfoVisible">
                                      <v-text-field label="Order Info" v-model="order.OrderInfoText"></v-text-field> 
                                      <v-btn color="info" @click="onSaveOrderInfo">{{$t('message.save')}}</v-btn>
                                  </div>
                                  <div v-if="isOrderPaymentDateVisible">
                                    <div class="layout row">
                                      <div class="flex xs12">
                                        <div class="text-xs-center button-row">
                                          <label for="paymantdate" class="datelabel">Invoice Date: </label>
                                          <input 
                                            type="date" 
                                            id="paymantdate"
                                            class="dateinput"
                                            v-model="order.payment_date"
                                            min="2022-01-05" 
                                            max="2030-12-31"
                                          >
                                          <label for="paymantdatedeadline" class="datelabel">Payment Deadline: </label>
                                          <input 
                                            type="date" 
                                            id="paymantdatedeadline"
                                            class="dateinput"
                                            v-model="order.payment_date_deadline"
                                            min="2022-01-05" 
                                            max="2030-12-31"
                                          >
                                          <v-btn 
                                            color="info" 
                                            @click="onSavePaymentDate">{{$t('message.save')}}
                                          </v-btn>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                              </div>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-tab-item>
                </v-tabs-items>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
import ArticleList from './ArticleList'
import AddressBox from './AddressBox'

export default {
  props: {
    isVisible: {
      type: Boolean,
      required: true
    },
    order: {
      type: Object,
     //  required: true
    }
  },
  components: {
    ArticleList,
    AddressBox
  },
  data() {
    return {
      tab: 'tab-settings',
      isMarkAsShippedVisible: false,
      isPlacedWithFOHESVisible: false,
      isRequiredLogoVisible: false,
      logo: null,
      isOrderInfoVisible: false,
      isOrderPaymentDateVisible: false,
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      modal: false,
      menu2: false
    }
  },
  computed: {
    ...mapGetters([
      'orders',
      'logos',
      'user'
    ]),
    paymentType () {
      return this.order.cc_brand
        .replace('UEBERWEISUNG', 'Bank transfer')
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    action (a) {
      
    },
    onMarkAsPaid () {
      this.$store.dispatch('markOrderAsPaid', {id: this.order.id })
    },
    onMarkAsShipped () {
        this.$store.dispatch('markOrderAsShipped', {
          id: this.order.id,
          ShippingTrackingNumber: this.order.ShippingTrackingNumber
        }).then(() => {
          this.isMarkAsShippedVisible = false
        })
    },
    onMarkAsPlacedWithFOHES () {
      this.$store.dispatch('markOrderAsPlacedWithFOHES', {
        id: this.order.id,
        FOHESInvoiceNumber: this.order.FOHESInvoiceNumber,
        FOHESConfirmationNumber: this.order.FOHESConfirmationNumber
      }).then(() => {
        this.isPlacedWithFOHESVisible = false
      })
    },
    onSaveRequiredLogo () {
      this.$store.dispatch('saveRequiredLogo', {id: this.order.id, logo: this.order.RequiredLogo })
        .then(() => {
          this.isRequiredLogoVisible = false
          this.$emit('close')
        })
    },
    onSaveOrderInfo () {
      this.$store.dispatch('saveOrderInfo', {
        id: this.order._id, 
        text: this.order.OrderInfoText 
      }).then(() => {
          this.isOrderInfoVisible = false
          this.$emit('close')
        })
    },
    onSavePaymentDate () {
      this.$store.dispatch('saveOrderPaymentDate', {
        id: this.order.id, 
        PaymentDate: this.order.payment_date,
        PaymentDateDeadline: this.order.payment_date_deadline
      }).then(() => {
          this.isOrderPaymentDate = false
          this.$emit('close')
        })
    },
    openTrackingPage () {
      window.open(`https://www.ups.com/WebTracking/processInputRequest?tracknum=${this.order.ShippingTrackingNumber}`, '_blank')
    },
    openInvoicePage () {
      window.open(`${this.order.customerInvoice}`, '_blank')
    }
  },
  created() {

  }
}
</script>
<style>
    .button-row {
        padding-top: 15px !important;
    }
    .dateinput {
      border-bottom: 1px solid black !important;
    }
    .datelabel {
      padding-right: 10px;
      padding-left: 50px;
    }
</style>